const CHANGES = [
  {
    icon: "ri-chat-3-line",
    title: "여행 필수 회화를 내 입으로",
    desc: "공항 · 호텔 · 식당 · 지하철에서 필요한 기본 문장을 직접 말할 수 있어요.",
  },
  {
    icon: "ri-emotion-line",
    title: "기본 자기소개와 짧은 대화",
    desc: "이름, 나이, 취미, 국적 등 자기소개와 가벼운 스몰토크가 가능해져요.",
  },
  {
    icon: "ri-headphone-line",
    title: "애니·드라마의 짧은 표현 캐치",
    desc: "짧고 자주 나오는 표현을 알아들으며 좋아하는 콘텐츠가 새롭게 보여요.",
  },
  {
    icon: "ri-bar-chart-2-line",
    title: "이후 학습으로 이어질 탄탄한 기초",
    desc: "중급 회화, JLPT N5·N4, 미디어 감상까지 이어갈 튼튼한 기본기가 남아요.",
  },
];

export default function Changes() {
  return (
    <section className="py-10 md:py-28 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-10">
        <div className="text-center mb-12">
          <span className="text-[10px] md:text-sm font-semibold tracking-widest text-primary-600 uppercase">
            After 8 Weeks
          </span>
          <h2 className="mt-3 font-heading text-xl md:text-4xl font-bold text-foreground-950">
            8주 후, 이렇게 달라져요
          </h2>
          <p className="mt-2 text-xs sm:text-base text-foreground-700">
            수업을 마쳤을 때 손에 남을 것들이에요.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
          {CHANGES.map((c, idx) => (
            <div
              key={c.title}
              className="relative bg-background-100 border border-background-200 rounded-xl p-3 sm:p-6 hover:border-accent-400 transition-colors"
            >
              <span className="absolute -top-3 left-6 px-2 py-0.5 sm:px-2.5 sm:py-1 rounded-full bg-accent-500 text-background-50 text-[10px] sm:text-xs font-bold">
                CHANGE 0{idx + 1}
              </span>
              <div className="flex items-start gap-3">
                <div className="mt-1 w-9 h-9 sm:w-12 sm:h-12 flex items-center justify-center rounded-lg bg-background-50 text-primary-600 text-xl sm:text-2xl border border-background-200 shrink-0">
                  <i className={c.icon}></i>
                </div>
                <div className="min-w-0">
                  <h3 className="font-heading text-sm sm:text-lg font-bold text-foreground-950 leading-snug break-all">
                    {c.title}
                  </h3>
                  <p className="mt-1 text-xs sm:text-sm text-foreground-700 leading-relaxed break-all">{c.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}